module.exports = __webpack_public_path__ + "img/cert3.c9f17812.png";